import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a8f86158&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a8f86158&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.29_babel-core@7.0.0-bridge.0_@babel+core@7.29._a7b6b2d0a8f0803019d019baabfbdad7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f86158",
  null
  
)

export default component.exports